import axios from "axios";
import { useEffect, useState } from "react";
import MentorAvailability from "../../dateComponent/MentorAvailability";
import ProfileHeader from "../ProfileHeader";
import "./MentorProfile.css";

// const BASE_URL = "http://localhost:8000";
const BASE_URL = "https://idealpursuits.co.in/api";

const daysOfWeek = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];

function MentorProfile({ userData }) {
    const [preferredTimes, setPreferredTimes] = useState([]);
    const [preferredDays, setPreferredDays] = useState([]);
    const [timeInput, setTimeInput] = useState("");
    const [selectedDays, setSelectedDays] = useState([]);
    const [meetingData, setMeetingData] = useState(null);
    const [isCustomDays, setIsCustomDays] = useState(false);
    const [meetingLength, setMeetingLength] = useState(30);  // Default meeting length is 30 minutes
    const [meetingCharge, setMeetingCharge] = useState(0);  // Default meeting charge is 0
    const [rating, setRating] = useState(0);  // Default meeting charge is 0
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(10);

    useEffect(() => {
        const fetchPreferences = async () => {
            try {
                const response = await axios.post(`${BASE_URL}/mentor/getMentorPreferences.php`, {
                    mentorId: userData.mentorId,
                });
                const data = response.data;
                setPreferredTimes(data.preferredTimes ? data.preferredTimes.split(",") : []);
                setPreferredDays(data.preferredDays ? data.preferredDays.split(",") : []);
                setMeetingCharge(data.meetingCharge);
                setMeetingLength(data.meetingLength);
            } catch (error) {
                console.error("Error fetching preferences:", error);
            }
        };
        fetchPreferences();
    }, [userData.mentorId]);

    useEffect(() => {
        const fetchMeetings = async () => {
            try {
                const response = await axios.post(`${BASE_URL}/getMeetingsForTutor.php`, { tutorId: userData.mentorId, tutorType: 'mentor' });
                let data = response.data;

                const today = new Date(); // Get today's date

            // Function to convert DD-MM-YYYY to a proper Date object
            const parseDate = (dateStr) => {
                const [day, month, year] = dateStr.split("-").map(Number);
                return new Date(year, month - 1, day); // Month is 0-based in JS
            };

            // Categorizing the meetings
            let todayMeetings = [];
            let futureMeetings = [];
            let pastMeetings = [];

            data.forEach(meeting => {
                const meetingDate = parseDate(meeting.meetingDate);

                if (meetingDate.toDateString() === today.toDateString()) {
                    todayMeetings.push(meeting); // Meetings happening today
                } else if (meetingDate > today) {
                    futureMeetings.push(meeting); // Future meetings
                } else {
                    pastMeetings.push(meeting); // Past meetings
                }
            });

            // Sort future meetings by closest to today
            futureMeetings.sort((a, b) => parseDate(a.meetingDate) - parseDate(b.meetingDate));

            // Sort past meetings by most recent first
            pastMeetings.sort((a, b) => parseDate(b.meetingDate) - parseDate(a.meetingDate));

            // Combine lists: today → future → past
            const sortedMeetings = [...todayMeetings, ...futureMeetings, ...pastMeetings];

                setMeetingData(sortedMeetings);
            } catch (error) {
                console.error("Error fetching mentor meetings:", error);
            }
        };

        fetchMeetings();
    }, []);

    useEffect(() => {
        if (meetingData) {
            const nonZeroRatings = meetingData
                .filter(meeting => Number(meeting.rating) > 0)  // Convert to number
                .map(meeting => Number(meeting.rating));
            const totalRating = nonZeroRatings.reduce((sum, rating) => sum + rating, 0);
            setRating(nonZeroRatings.length > 0 ? totalRating / nonZeroRatings.length : 0);
        }
    }, [meetingData]);

    const handleSavePreferences = async () => {
        try {
            await axios.post(`${BASE_URL}/mentor/saveMentorPreferences.php`, {
                mentorId: userData.mentorId,
                preferredTimes: preferredTimes.join(","),
                preferredDays: isCustomDays
                    ? selectedDays.join(",")
                    : daysOfWeek.slice(0, 5).join(","),
                meetingLength,
                meetingCharge
            });
            alert("Preferences saved successfully!");
        } catch (error) {
            console.error("Error saving preferences:", error);
        }
    };

    const formatToDate = (dateString) => {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-based
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
    };

    // Pagination calculation
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = meetingData ? meetingData.slice(indexOfFirstItem, indexOfLastItem) : [];
    const totalPages = meetingData ? Math.ceil(meetingData.length / itemsPerPage) : 0;

    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    return (
        <div>
            <ProfileHeader />
            <div className="mentor-profile-body">
                <div className="mentor-profile-dp">
                    {userData.profileImageName ? (
                        <img
                            src={`${BASE_URL}/images/profile/${userData.profileImageName}`}
                            alt={userData.name}
                            className='profile-image'
                        />
                    ) : (
                        <p>No Image</p>
                    )}
                </div>
                <div className="mentor-profile-container">
                    <h2>Welcome, {userData.name}</h2>
                    <h4>Your Rating: ⭐{rating.toFixed(1)}</h4>
                    <p>Here you can manage your availability and meeting preferences.</p>
                    <MentorAvailability userData={userData} />

                    <div className="meeting-settings">
                        <div className="meeting-length-section">
                            <h3>Meeting Length(min)</h3>
                            <input
                                type="number"
                                value={meetingLength}
                                onChange={(e) => setMeetingLength(e.target.value)}
                                min="1"
                            />
                        </div>

                        <div className="meeting-charge-section">
                            <h3>Meeting Charge(₹)</h3>
                            <input
                                type="number"
                                value={meetingCharge}
                                onChange={(e) => setMeetingCharge(e.target.value)}
                                min="0"
                            />
                        </div>
                    </div>
                    <button onClick={handleSavePreferences} className="save-button">
                        Save Preferences
                    </button>

                    <h2>Your Scheduled Meetings:</h2>
                    {meetingData && meetingData.length > 0 ? (
                        <>
                            <table>
                                <thead>
                                    <tr>
                                        <th>Date</th>
                                        <th>Time</th>
                                        <th>With</th>
                                        <th>Charge</th>
                                        <th>Rating</th>
                                        <th>Link</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {currentItems.map((meeting) => (
                                        <tr key={meeting.meetingId}>
                                            <td>{formatToDate(meeting.meetingDate)}</td>
                                            <td>{meeting.meetingTime}</td>
                                            <td>{meeting.userName}</td>
                                            <td>{meeting.meetingCharge}</td>
                                            <td>{meeting.rating > 0 ?
                                                (<span>⭐{parseFloat(meeting.rating).toFixed(1)}</span>
                                                ) : (
                                                    <span>Not rated.</span>
                                                )}
                                            </td>
                                            <td><a href={meeting.meetingLink}>Link</a></td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <div className="pagination-container">
                                <button
                                    onClick={() => paginate(currentPage - 1)}
                                    disabled={currentPage === 1}
                                    className="pagination-button"
                                >
                                    &lt;
                                </button>
                                <span className="pagination-info">
                                    {currentPage} of {totalPages}
                                </span>
                                <button
                                    onClick={() => paginate(currentPage + 1)}
                                    disabled={currentPage === totalPages}
                                    className="pagination-button"
                                >
                                    &gt;
                                </button>
                            </div>
                        </>
                    ) : (
                        <p>No meetings scheduled.</p>
                    )}
                </div>
            </div>
        </div>
    );
}

export default MentorProfile;